import { callDelete, callGet, callPost, } from "./index";
import { AtticusForm } from "../models/AtticusForm";
import { FormType } from "models/FormType";
import { GeographyType } from "models/Geography";
import { KNOWLEDGE_FILLED_FORM_GENERATOR_URL } from "../constants";

export interface QueryPayload {
  geography_type?: GeographyType;
  geography_id?: number;
  form_type_id?: number;
  search_terms?: string;
  language_id?: number;
  geography_inclusive?: boolean;
}

export class FormsAPI {
  async fetchForms(estateId: number, queryPayload: QueryPayload): Promise<AtticusForm[] | null> {
    const fullPath = `estates/${estateId}/forms/query`;
    const response = await callPost(fullPath, {
      geography_type: queryPayload.geography_type,
      geography_id: queryPayload.geography_id,
      form_type_id: queryPayload.form_type_id,
      search_terms: queryPayload.search_terms,
      language_id: queryPayload.language_id,
      geography_inclusive: queryPayload.geography_inclusive || true,
    });

    const forms: AtticusForm[] = [];
    response?.data?.forEach((form: any) => {
      const newForm = AtticusForm.fromJSON(form);
      forms.push(newForm);
    });
    return forms;
  }

  async getFormLimited(estateId: number, formId: number): Promise<AtticusForm | undefined> {
    try {
      const response = await callGet(
        `estates/${estateId}/forms/${formId}/limited`,
        true
      );
      return AtticusForm.fromJSON(response?.data);
    } catch (error) {
      console.error(error, "getFormLimited error");
      return undefined;
    }
  }

  async fetchFormTypes(): Promise<FormType[] | undefined> {
    const fullPath = `forms/form-types`;
    const response = await callGet(fullPath);

    const formTypes: FormType[] = [];
    response?.data?.forEach((formType: any) => {
      formTypes.push(FormType.fromJSON(formType));
    });

    return formTypes;
  }

  async getStateProbateForms(
    estateId: number,
    stateId: number,
    terms = "",
    language_id = 1,
    rethrowError = false
  ): Promise<AtticusForm[] | undefined> {
    return await this.getForms(
      estateId, 
      1,// Probate
      "State",
      stateId,
      terms,
      language_id,
      rethrowError
    );
  }

  async getForms(
    estateId: number,
    formTypeId: number,
    geoType: string,
    geoId: number,
    terms = "",
    language_id = 1,
    rethrowError = false
  ): Promise<AtticusForm[] | undefined> {
    try {
      let path = `estates/${estateId}/forms/type/${formTypeId}/geo/${geoType}/${geoId}`;
      path += `?language_id=${language_id}&terms=${terms}`;
      const response = await callGet(path, rethrowError);
      return response?.data?.map((json: any) => AtticusForm.fromJSON(json));
    } catch (error) {
      console.error(error, "getForms error");
    }
  }

  async getFormsForEstate(
    estateId: number
  ): Promise<AtticusForm[] | undefined> {
    const path = `forms/estates/${estateId}`;
    const response = await callGet(path);
    return response?.data?.map((json: any) => AtticusForm.fromJSON(json));
  }

  async addFormForEstate(
    estateId: number,
    formId: number,
    rethrowError = false
  ): Promise<boolean | undefined> {
    try {
      const path = `estates/${estateId}/forms/${formId}`;
      await callPost(path, {}, rethrowError);
      return true;
    } catch (error) {
      if (rethrowError) {
        throw error;
      } else {
        console.error(error, "getForms error");
      }
    }
  }

  async removeFormForEstate(
    estateId:number,
    formId: number,
    rethrowError = false
  ): Promise<boolean | undefined> {
    try {
      const path = `estates/${estateId}/forms/${formId}`;
      await callDelete(path, rethrowError);
      return true;
    } catch (error) {
      if (rethrowError) {
        throw error;
      } else {
        console.error(error, "getForms error");
      }
    }
  }
}
